/**
 * 头像
 */

import React from 'react';
import { getQiniuImageCompressedUrl } from '../../../shared/utils/fileHelper';
import MedImage from '../LazyImage';

interface Props extends React.ComponentProps<typeof MedImage> {
  size?: number;
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const defaultAvatar = require('./avatar.png');

export default (props: Props) => {
  const { size = 200, ...rest } = props;
  const url = getQiniuImageCompressedUrl(props.src || '', size, size);

  return <MedImage {...rest} src={url} defaultSrc={defaultAvatar} />;
};
